import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e8f731f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal__header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "modal__title" }, [
  /*#__PURE__*/_createTextVNode(" Стандарт оценки "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" модифицированного индекса "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" кровоточивости ")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "index-blooding" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "index-blooding__paragraph" }, [
    /*#__PURE__*/_createTextVNode(" Зондирование проводится в четырёх точках у зубов Рамфьёрда "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 16, 21, 24, 36, 41, 44 ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "index-blooding__items" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "index-blooding__item" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "index-blooding__value" }, "0"),
      /*#__PURE__*/_createElementVNode("div", { class: "index-blooding__description" }, " Отсутствие кровотечения при зондировании ")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "index-blooding__item" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "index-blooding__value" }, "1"),
      /*#__PURE__*/_createElementVNode("div", { class: "index-blooding__description" }, " Наличие кровотечения при зондировании ")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "index-blooding__paragraph" }, " Подсчитывается количество баллов "),
  /*#__PURE__*/_createElementVNode("p", { class: "index-blooding__paragraph" }, " Индекс = количество баллов / 24 * 100 "),
  /*#__PURE__*/_createElementVNode("p", { class: "index-blooding__paragraph" }, "Результат в процентах")
], -1))


import IconTemplate from '@/apps/components/IconTemplate.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  isModalVisible: {
    type: Boolean,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: __props.isModalVisible,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(isModalVisible) ? (isModalVisible).value = $event : null)),
    "show-close": false,
    width: "538"
  }, {
    header: _withCtx(({ close }) => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(IconTemplate, {
          class: "modal__header-icon",
          height: "25",
          name: "close",
          width: "25",
          onClick: close
        }, null, 8, ["onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _hoisted_3
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})